import React from "react";

/**
 * Simplified Escudo Nacional del Perú (Vicuña, Cinchona tree, Cornucopia).
 * Not the exact heraldic emblem — used as a visual marker for the Peruvian
 * institutional identity within the Pumaria brand.
 */
const EscudoNacional = ({ size = 44, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 72"
    width={size}
    height={size * (72 / 64)}
    className={className}
    role="img"
    aria-label="Escudo Nacional del Perú"
  >
    {/* Shield */}
    <path
      d="M32 4 L58 8 L58 34 C58 52 46 64 32 68 C18 64 6 52 6 34 L6 8 Z"
      fill="#0B1F3A"
      stroke="#B48438"
      strokeWidth="1.5"
    />
    {/* Top-left blue quarter — sky (Vicuña) */}
    <path d="M6 8 L32 4 L32 34 L6 34 Z" fill="#1C3A6B" />
    {/* Top-right white quarter — Cinchona tree */}
    <path d="M32 4 L58 8 L58 34 L32 34 Z" fill="#F4F6FA" />
    {/* Bottom red quarter — Cornucopia */}
    <path
      d="M6 34 L58 34 L58 34 C58 52 46 64 32 68 C18 64 6 52 6 34 Z"
      fill="#D91E18"
    />

    {/* Vicuña silhouette (top-left) */}
    <g fill="#F4F6FA">
      <path d="M14 26 c1-2 3-3 5-3 c1 -2 4 -2 5 0 c1 1 0 2 -1 2 c1 1 1 2 0 3 c-1 1 -3 1 -4 0 c-1 1 -3 1 -4 0 c-1 -1 -1 -2 -1 -2 z" />
      <circle cx="22" cy="22" r="1.2" fill="#0B1F3A" />
    </g>

    {/* Cinchona tree (top-right) */}
    <g>
      <rect x="44" y="24" width="1.4" height="8" fill="#5b3d1a" />
      <circle cx="42" cy="22" r="3" fill="#0FA36B" />
      <circle cx="47" cy="22" r="3" fill="#0FA36B" />
      <circle cx="44.5" cy="19" r="3" fill="#0C8A5A" />
    </g>

    {/* Cornucopia (bottom) - coins spilling */}
    <g>
      <path
        d="M22 46 C28 44 36 44 42 46 L40 52 C36 51 28 51 24 52 Z"
        fill="#F1C36B"
        stroke="#B48438"
        strokeWidth="0.6"
      />
      <circle cx="30" cy="55" r="1.4" fill="#F1C36B" />
      <circle cx="34" cy="57" r="1.4" fill="#F1C36B" />
      <circle cx="38" cy="55" r="1.4" fill="#F1C36B" />
    </g>

    {/* Bottom ribbon */}
    <path d="M6 62 L58 62 L54 68 L10 68 Z" fill="#B48438" opacity="0.75" />
  </svg>
);

export default EscudoNacional;
